import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService } from './FootprintManager.manufacturing_order_line_production_confirmation_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Manufacturing_material_packagings_dd_singleComponent } from './Manufacturing.material_packagings_dd_single.component'
import { Manufacturing_licenseplates_by_location_singleComponent } from './Manufacturing.licenseplates_by_location_single.component'
import { Manufacturing_lots_by_material_ids_singleComponent } from './Manufacturing.lots_by_material_ids_single.component'


interface IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentEntity {
  lineNumber?: number, finishedProduct?: string, plannedQuantity?: number, producedQuantity?: number, packaging?: number, targetLicensePlate?: number, lot?: number, id?: number, license_plate_name?: string, lot_name?: string, packaging_name?: string}

interface IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentInParams {
  finished_good?: string, planned_quantity?: number, material_id?: number, output_location_id?: number}

interface IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentOutParams {
  license_plate_ids?: { amountToIncrease?: number, licensePlate?: number, lotId?: number, materialId?: number, packaging?: number }[], actual_produced_quantity?: number}

class FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent;
  entity: IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentEntity;


  options: { delete_action: ButtonModel } = {
    delete_action: new ButtonModel('delete_action', new ButtonStyles(null, null), false, false, false, 'Delete', '', null)

  }

 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    produced_quantity_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    packaging_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    target_license_plate_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    lot_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    lot_expiration_display: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  override cells = {
    line_number: null,
    finished_product: null,
    planned_quantity: null,
    produced_quantity: null,
    packaging: null,
    target_license_plate: null,
    lot: null,
    lot_expiration: null,
  }

  get $fields_packaging_selector_inParams_material_id(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $grid.inParams.material_id;
    
    return expr;
  }
  get $fields_target_license_plate_selector_inParams_location_id(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $grid.inParams.output_location_id;
    
    return expr;
  }
  cacheValueFor_$fields_lot_selector_inParams_material_ids: number[];
  get $fields_lot_selector_inParams_material_ids(): number[] {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = [$grid.inParams.material_id];
    
    if(!isEqual(this.cacheValueFor_$fields_lot_selector_inParams_material_ids, expr)) {
      this.cacheValueFor_$fields_lot_selector_inParams_material_ids = expr;
    }
    return this.cacheValueFor_$fields_lot_selector_inParams_material_ids;
  }


  constructor(
    grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.line_number = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.line_number,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.finished_product = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.finished_product,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.planned_quantity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.planned_quantity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.produced_quantity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.produced_quantity,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['produced_quantity_edit'] as DatexFormControl, null, false, false, '', '', null)
      );
    
    this.cells.packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['packaging_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.target_license_plate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.target_license_plate,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['target_license_plate_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['lot_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.lot_expiration = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot_expiration,
      new DateBoxModel(this.formGroup.controls['lot_expiration_display'] as DatexFormControl, null, true, false, '', 'date', null)
,
null
      );
    
    
    this.formGroup
      .controls['lot_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_lot_changed();
      });
  }

  async $initializeExisting(entity: IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
      await this.on_init_row();
    }

    this.rowId = [this.entity.id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.id;
    const inParams = {
      $keys:[$resultKey],
    };
    const data = await this.$datasources.Manufacturing.ds_manufacturing_order_production_confirmation_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.finished_product.displayControl as TextModel).text = $grid.inParams.finished_good;
    (this.cells.planned_quantity.displayControl as TextModel).text = $grid.inParams.planned_quantity.toString();

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_save_new_row');
  const packageRequest = await $datasources.Manufacturing.ds_get_material_packaging_by_materialId_and_packagingId.get({material_id: $grid.inParams.material_id, packaging_id: $row.cells.packaging.editControl.value});
  if( $utils.isDefined(packageRequest) && packageRequest.result.length > 0 )
  {
      const packaging = packageRequest.result[0];
      $row.cells.packaging.displayControl.text = packaging.Packaging?.ShortName;
  }
  
  const lotRequest = await $datasources.Manufacturing.ds_get_lots_by_materialIds.get({materialIds: [$grid.inParams.material_id], lot_id: $row.cells.lot.editControl.value});
  if( $utils.isDefined(lotRequest) && lotRequest.result.length > 0 )
  {
      const lot = lotRequest.result[0];
      $row.cells.lot.displayControl.text = lot.LookupCode;
      $row.cells.lot_expiration.displayControl.value = lot.VendorLot?.ExpirationDate;
  }
  
  const licensePlateRequest = await $datasources.Manufacturing.ds_get_licenseplates_by_locationId.get({locationId: $grid.inParams.output_location_id, license_plate_ids: [$row.cells.target_license_plate.editControl.value]});
  if( $utils.isDefined(licensePlateRequest) && licensePlateRequest.result.length > 0 )
  {
      const licensePlate = licensePlateRequest.result[0];
      $row.cells.target_license_plate.displayControl.text = licensePlate?.LookupCode;
  }
  
  $row.cells.produced_quantity.displayControl.text = $row.cells.produced_quantity.editControl.value;
  
  $grid.outParams.license_plate_ids = [];
  
  let totalProduced = 0;
  
  $grid.rows.forEach( x => {
      totalProduced += x.cells.produced_quantity.editControl.value;
      const rowData = {materialId: $grid.inParams.material_id, amountToIncrease: x.cells.produced_quantity.editControl.value, licensePlate: x.cells.target_license_plate.editControl.value, lotId: x.cells.lot.editControl.value, packaging: x.cells.packaging.editControl.value};
      $grid.outParams.license_plate_ids.push(rowData);
  })
  
  $grid.outParams.actual_produced_quantity = totalProduced;
  
  $grid.events.outParamsChange.emit();
  }
  on_init_row(event = null) {
    return this.on_init_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_rowInternal(
    $row: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_init_row');
  
  $row.cells.line_number.displayControl.text = ( $grid.rows.length + 1 ).toString();
  $row.entity.lineNumber = $grid.rows.length + 1;
  $row.cells.produced_quantity.editControl.value = $grid.inParams.planned_quantity;
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_save_existing_row');
  
  const packageRequest = await $datasources.Manufacturing.ds_get_material_packaging_by_materialId_and_packagingId.get({material_id: $grid.inParams.material_id, packaging_id: $row.cells.packaging.editControl.value});
  if( $utils.isDefined(packageRequest) && packageRequest.result.length > 0 )
  {
      const packaging = packageRequest.result[0];
      $row.cells.packaging.displayControl.text = packaging.Packaging?.ShortName;
  }
  
  const lotRequest = await $datasources.Manufacturing.ds_get_lots_by_materialIds.get({materialIds: [$grid.inParams.material_id], lot_id: $row.cells.lot.editControl.value});
  if( $utils.isDefined(lotRequest) && lotRequest.result.length > 0 )
  {
      const lot = lotRequest.result[0];
      $row.cells.lot.displayControl.text = lot.LookupCode;
      $row.cells.lot_expiration.displayControl.value = lot.VendorLot?.ExpirationDate;
  }
  
  const licensePlateRequest = await $datasources.Manufacturing.ds_get_licenseplates_by_locationId.get({locationId: $grid.inParams.output_location_id, license_plate_ids: [$row.cells.target_license_plate.editControl.value]});
  if( $utils.isDefined(licensePlateRequest) && licensePlateRequest.result.length > 0 )
  {
      const licensePlate = licensePlateRequest.result[0];
      $row.cells.target_license_plate.displayControl.text = licensePlate?.LookupCode;
  }
  
  $row.cells.produced_quantity.displayControl.text = $row.cells.produced_quantity.editControl.value;
  
  $grid.outParams.license_plate_ids = [];
  
  let actualProducedQuantity = 0;
  
  $grid.rows.forEach( x => {
      actualProducedQuantity += x.cells.produced_quantity.editControl.value;
      const rowData = {materialId: $grid.inParams.material_id, amountToIncrease: x.cells.produced_quantity.editControl.value, licensePlate: x.cells.target_license_plate.editControl.value, lotId: x.cells.lot.editControl.value, packaging: x.cells.packaging.editControl.value};
      $grid.outParams.license_plate_ids.push(rowData);
  })
  
  $grid.outParams.actual_produced_quantity = actualProducedQuantity;
  
  $grid.events.outParamsChange.emit();
  }
  on_lot_changed(event = null) {
    return this.on_lot_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_changedInternal(
    $row: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_lot_changed');
  const lotRequest = await $datasources.Manufacturing.ds_get_lots_by_materialIds.get({materialIds: [$grid.inParams.material_id], lot_id: $row.cells.lot.editControl.value});
  if( $utils.isDefined(lotRequest) && lotRequest.result.length > 0 )
  {
      const lot = lotRequest.result[0];
      $row.cells.lot_expiration.displayControl.value = lot.VendorLot?.ExpirationDate;
      $row.entity.lot = $row.cells.lot.editControl.value;
  }
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $row: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_delete_clicked');
  
  $grid.rows = $grid.rows.splice($row.entity.lineNumber, 1);
  
  $grid.outParams.license_plate_ids = [];
  
  let index = 0;
  
  $grid.rows.forEach( x => {
  
      index++;
      x.cells.line_number.displayControl.text = index.toString();
  
      const rowData = {materialId: $grid.inParams.material_id, amountToIncrease: x.cells.produced_quantity.editControl.value, licensePlate: x.cells.target_license_plate.editControl.value, lotId: x.cells.lot.editControl.value, packaging: x.cells.packaging.editControl.value};
      $grid.outParams.license_plate_ids.push(rowData);
  })
  
  $grid.events.outParamsChange.emit();
  }
  on_produced_quantity_changed(event = null) {
    return this.on_produced_quantity_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_produced_quantity_changedInternal(
    $row: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_produced_quantity_changed');
  
  $row.entity.producedQuantity = $row.cells.produced_quantity.editControl.value;
  }
  on_packaging_changed(event = null) {
    return this.on_packaging_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_packaging_changedInternal(
    $row: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_packaging_changed');
  
  $row.entity.packaging = $row.cells.packaging.editControl.value;
  }
  on_target_license_plate_changed(event = null) {
    return this.on_target_license_plate_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_target_license_plate_changedInternal(
    $row: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel,
  $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_target_license_plate_changed');
  
  $row.entity.license_plate_name = $row.cells.target_license_plate.editControl.value;
  
  $row.cells.lot.editControl.value = null;
  $row.cells.lot.displayControl.text = "";
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Manufacturing_material_packagings_dd_singleComponent),
    forwardRef(() => Manufacturing_licenseplates_by_location_singleComponent),
    forwardRef(() => Manufacturing_lots_by_material_ids_singleComponent),
  ],
  selector: 'FootprintManager-manufacturing_order_line_production_confirmation_grid',
  templateUrl: './FootprintManager.manufacturing_order_line_production_confirmation_grid.component.html'
})
export class FootprintManager_manufacturing_order_line_production_confirmation_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentInParams = { finished_good: null, planned_quantity: null, material_id: null, output_location_id: null };

  outParams: IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentOutParams = { license_plate_ids: [], actual_produced_quantity: null };

  //#region Variables
  //#endregion
  //#region Events
  @Output()
  outParamsChange = new EventEmitter<{ license_plate_ids?: { amountToIncrease?: number, licensePlate?: number, lotId?: number, materialId?: number, packaging?: number }[], actual_produced_quantity?: number }>();
  
  events = {
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  headers = {
     line_number: new GridHeaderModel(new HeaderStyles(null, null), 'line_number', '#', false, false, null, false),       finished_product: new GridHeaderModel(new HeaderStyles(null, null), 'finished_product', 'Finished product', false, false, null, false),       planned_quantity: new GridHeaderModel(new HeaderStyles(null, null), 'planned_quantity', 'Planned quantity', false, false, null, false),       produced_quantity: new GridHeaderModel(new HeaderStyles(null, null), 'produced_quantity', 'Produced quantity', true, false, null, false),       packaging: new GridHeaderModel(new HeaderStyles(null, null), 'packaging', 'Packaging', true, false, null, false),       target_license_plate: new GridHeaderModel(new HeaderStyles(null, null), 'target_license_plate', 'Target license plate', true, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', true, false, null, false),       lot_expiration: new GridHeaderModel(new HeaderStyles(null, null), 'lot_expiration', 'Lot expiration', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel[] = [];

  @Input('finished_good') set $inParams_finished_good(value: any) {
    this.inParams['finished_good'] = value;
  }
  get $inParams_finished_good(): any {
    return this.inParams['finished_good'] ;
  }
  @Input('planned_quantity') set $inParams_planned_quantity(value: any) {
    this.inParams['planned_quantity'] = value;
  }
  get $inParams_planned_quantity(): any {
    return this.inParams['planned_quantity'] ;
  }
  @Input('material_id') set $inParams_material_id(value: any) {
    this.inParams['material_id'] = value;
  }
  get $inParams_material_id(): any {
    return this.inParams['material_id'] ;
  }
  @Input('output_location_id') set $inParams_output_location_id(value: any) {
    this.inParams['output_location_id'] = value;
  }
  get $inParams_output_location_id(): any {
    return this.inParams['output_location_id'] ;
  }

  topToolbar = {
      add_license_plate: new ToolModel(new ButtonModel('add_license_plate', new ButtonStyles(null, null), false, false, false, 'Add license plate', 'icon-ic_fluent_add_circle_20_regular', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Order line production confirmation';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
    };
    try {
      const data = await this.$datasources.Manufacturing.ds_manufacturing_order_production_confirmation_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_init_flow();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: IFootprintManager_manufacturing_order_line_production_confirmation_gridComponentEntity) {
    const row = new FootprintManager_manufacturing_order_line_production_confirmation_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init_flow(event = null) {
    return this.on_init_flowInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_flowInternal(
    $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_init_flow');
  
  $grid.bottomToolbar.addLine.hidden = true;
  
  const newRow = await $grid.addRow();
  
  newRow.cells.produced_quantity.editControl.value = $grid.inParams.planned_quantity;
  newRow.cells.produced_quantity.editControl.focus();
  }
  on_add_new_license_plate_clicked(event = null) {
    return this.on_add_new_license_plate_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_add_new_license_plate_clickedInternal(
    $grid: FootprintManager_manufacturing_order_line_production_confirmation_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_order_line_production_confirmation_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_order_line_production_confirmation_grid.on_add_new_license_plate_clicked');
  
  const newRow = await $grid.addRow();
  
  newRow.cells.produced_quantity.editControl.focus();
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
